/**
 * Created by Administrador on 17/11/2017.
 */
(function () {
    'use strict';

    angular
        .module('completeAir')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider', 'CONFIG'];

    function stateConfig($stateProvider, CONFIG) {
        $stateProvider
            .state('subClassificationsSsr', {
                parent: 'app',
                url: '/subClassificationsSsr?page&size',
                params: {
                    page: "0",
                    size: "10"
                },
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                views: {
                    'main@': {
                        templateUrl: 'app/admin/ssr/settingSsr/subClassification/subClassifications.html',
                        controller: 'subClassificationSsrCtrl',
                        controllerAs: 'vm',
                        resolve: {
                            tabs: ['tabService', function (tabService) {
                                return tabService.getTabAdminClassificationsSsr('subClassificationsSsr'); // default selected
                            }],
                            translatePartialLoader: ['translationHandler', function (translationHandler) {
                                return translationHandler.translateRefresh(['subClassificationSsr']);
                            }],
                            subClassifications: ['subClassificationSsrService', '$stateParams', function (subClassificationSsrService, $stateParams) {
                                return subClassificationSsrService.getSubClassificationsSsr($stateParams.page, $stateParams.size);
                            }],
                            fareSubClassifications: ['fareSubClassificationSsrService', function (fareSubClassificationSsrService) {
                                return fareSubClassificationSsrService.getFareSubClassificationListSsr();
                            }]
                        }
                    }
                }
            })
    }
})();
